import React from 'react'
import {useForm} from "react-hook-form";
import {getMe, putPlaces} from "../../../../redux/actions";
import {Button, Form, Header} from "semantic-ui-react";

export const PagSeguro = ({item}) => {
    const {register, handleSubmit, formState} = useForm();
    const onSubmit = async data => {
        try {
            await putPlaces(data);
            const res = await getMe();

            sessionStorage.setItem('Data', JSON.stringify(res.data))

        } catch (e) {
            alert('error')
        }
    };

    return <React.Fragment>
        <Header textAlign={"center"}>
            Dados de Pagamento
        </Header>
        <Form onSubmit={handleSubmit(onSubmit)} loading={formState.isSubmitting}>
            <input type={'hidden'} name={'id'} defaultValue={item.id} ref={register()}/>
            <Form.Field>
                <label>URL para receber as notificações</label>
                <input
                    value={`https://br.inbh.com.br/v1/payments/add/${item.id}.json`}
                    readOnly={true}
                />
            </Form.Field>
            <Form.Field>
                <label>Página de redirecionamento</label>
                <input
                    value={'https://inbh.com.br/people'}
                    readOnly={true}
                />
            </Form.Field>
            <Form.Field>
                <label>Token de Segurança ( PagSeguro )</label>
                <textarea
                    name={'pagseguro_token'}
                    defaultValue={item.pagseguro_token}
                    ref={register({required: true})}
                    rows={3}
                />
            </Form.Field>
            <Button
                fluid
                primary
                content={'Salvar'}
                disabled={formState.isSubmitting}
                loading={formState.isSubmitting}
            />
        </Form>
    </React.Fragment>
}